import React from 'react';

export default function SummaryCard({ summary, classification }) {
  if (!summary) return null;

  return (
    <div className="summary-card">
      <div className="summary-title">
        📋 Resumo da Análise
      </div>
      <div className="summary-text">{summary.text}</div>
      {summary.tags && summary.tags.length > 0 && (
        <div className="summary-tags">
          {summary.tags.map((tag, i) => (
            <span key={i} className={`summary-tag ${tag.type || 'info'}`}>
              {tag.icon} {tag.label}
            </span>
          ))}
        </div>
      )}
    </div>
  );
}
